import { Mediator, app, payload } from "modular-openscriptjs";
import { eParse, inform, approved } from "../helpers";
import { STRINGS, api, dc, uc } from "../declarations";
import { analyze } from "../analytics";
import { routes } from "../backendRoutes";
import { $e } from "../ojs.events";

export class Capa extends Mediator {
	$$capa = {
		needs: {
			deposit: (ed, event) => this.send($e.capa.needs.depositForm, ed),
			transfer: (ed, event) => this.send($e.capa.needs.transferForm, ed),
			purchase: (ed, event) => this.purchase(ed, event),
			payment: (ed, event) => this.getPayment(ed, event),
			balance: (ed, event) => this.getBalance(),
			to: {
				initiateTransfer: (ed, event) => this.transferCapa(ed, event),
				initiateWithdraw: (ed, event) => this.withdrawCapa(ed, event),
			},
		},

		deposited_transferred_withdrawn: (ed, event) => this.getBalance(ed, event),
	};

	$$user = {
		authenticated: (ed, event) => this.send($e.capa.needs.balance),
		loggedOut: (ed, event) => this.setCapa(),
	};

	$$payment = {
		completed: (ed, event) => {
			this.getBalance(ed, event);

			let data = eParse(ed);
			if (data.meta.get("type") != "capa-purchase") {
				return;
			}

			inform("Capa purchase complete", STRINGS.SUCCESS);

			let amt = app('router').params.amount;
			const capaExchangeRate = window.systemConfigs.capaExchangeRate;

			analyze("wallet_deposit", {
				value: Math.floor(amt / capaExchangeRate),
				event_category: "Wallet",
				event_label: "Deposit",
				occasion: "capa-purchase",
				wallet_currency: "Capa",
				conversion_rate: capaExchangeRate,
				fiat_currency: userCurrency,
				fiat_amount: amt,
			});

			app("router").to(`/wallet`);
		},
	};

	async purchase(ed, event) {
		let data = eParse(ed);
		let res = await api.post(`${routes.capaPurchases}`, {
			amount: data.message.get("amount", 0),
		});

		if (!res) {
			return this.send($e.capa.has.depositError, ed);
		}

		inform(res.message, STRINGS.SUCCESS);
		this.send($e.capa.is.depositing, ed);

		this.send(
			$e.capa.needs.payment,
			payload({
				purchaseId: res.data.purchase.id,
				purchase: res.data.purchase,
				amount: res.data.purchase.amount,
			})
		);
	}

	getPayment(ed, event) {
		let data = eParse(ed);

		if (data.message.get("purchaseId", 0) == 0) {
			inform("Invalid purchase", STRINGS.ERROR);
			app("router").to("/");
			return;
		}

		let purchaseId = data.message.get("purchaseId");

		data.meta.put("route", `${routes.capaPurchases}/${purchaseId}/pay`);

		data.meta.put("type", "capa-purchase");
		data.meta.put("typeId", purchaseId);

		if (uc.paymentMethod) {
			uc.paymentMethod.value = "mpesa";
		} else {
			uc.states({
				paymentMethod: "mpesa",
			});
		}

		this.broadcast(
			$e.payment.needs.collection,
			payload(data.message, data.meta)
		);
	}

	async getBalance(ed, event) {
		let res = await api.get(`${routes.users}/capa`);

		if (!res) {
			this.setCapa();
			return;
		}

		this.setCapa(res.data.capa);
		this.send($e.capa.has.balance);
	}

	setCapa(capa = { balance: 0 }) {
		uc.capa.value = capa;
	}

	async transferCapa(ed, event) {
		let data = eParse(ed);

		let amount = data.message.get("amount");
		let account = data.message.get("account").replace(/-/g, "");

		if (amount <= 0) {
			inform("Amount should be greater than 0", STRINGS.ERROR);
			return this.broadcast($e.capa.has.transferError, ed);
		}

		if (account.length < 1) {
			inform("Account Number is required", STRINGS.ERROR);
			return this.broadcast($e.capa.has.transferError, ed);
		}

		// Fetch the username attached to the wallet account number
		let res = await api.get(`${routes.users}/capa/account/${account}/username`);
		if (!res || !res.data || !res.data.username) {
			inform(res?.message || "Unknown account number", STRINGS.ERROR);
			return this.broadcast($e.capa.has.transferError, ed);
		}

		const username = res.data.username;

		if (!approved(event, ed, `Are you sure you want to transfer ${dc.capaSymbol}${amount} to @${username}?`)) {
			return this.broadcast($e.capa.has.transferError, ed);
		}

		let response = await api.post(
			`${routes.users}/capa/transfer/${amount}/to/${account}`
		);

		if (!response) return this.broadcast($e.capa.has.transferError, ed);

		inform(response.message, STRINGS.SUCCESS);

		return this.broadcast($e.capa.transferred, ed);
	}

	async withdrawCapa(ed, event) {
		if (!approved(event, ed, "You want to withdraw this amount from your Capa wallet")) {
			return;
		}

		let data = eParse(ed);
		let amount = data.message.get("amount");
		let phone = data.message.get("phone");

		if (amount <= 0) {
			inform("Amount must be greater than 0", STRINGS.ERROR);
			return this.broadcast($e.capa.has.withdrawError, ed);
		}

		if (phone.length < 9) {
			inform("A valid phone number is required", STRINGS.ERROR);
			return this.broadcast($e.capa.has.withdrawError, ed);
		}

		let response = await api.post(
			routes.payouts,
			{
				amount,
				phone
			}
		);

		if (!response) return this.broadcast($e.capa.has.withdrawError, ed);

		inform(response.message, STRINGS.SUCCESS);

		return this.broadcast($e.capa.withdrawn, ed);
	}
}
